import { Routes } from "@/scripts/models/enums/routes.enum.js";

// Checkout de destino ao doar: o novo (CheckoutV2), salvo campanhas que ainda usam o
// modelo antigo de produtos (useLegacyProductFramework), que seguem no carrinho antigo.
export function getCheckoutRoute(campaign) {
  return campaign && campaign.useLegacyProductFramework
    ? Routes.web.CartLogged
    : Routes.web.CheckoutV2;
}
